import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AssessmentAreaBasicModel } from './assessment-area.model';

const localApiUrl = `${environment.apiUrl}/AssessmentAreas`;

@Injectable()
export class AssessmentAreasService {

  constructor(private http: HttpClient) { }

  getAll(): Promise<AssessmentAreaBasicModel[]> {
    return this.http.get<AssessmentAreaBasicModel[]>(`${localApiUrl}/All`).toPromise();
  }

}
